import { makeScripts } from 'src/main/factories/pages'

export default makeScripts
